import { Message } from 'element-ui';
import loadingMask from '@/components/loading-mask';

let msg = null;
let showCount = 0;

export function show(option = {}) {
  let loading;
  if (typeof option === 'object') {
    let { mask = false } = option;
    if (mask) {
      loading = loadingMask;
    } else {
      loading = Message;
    }
  } else {
    loading = loadingMask;
  }

  showCount += 1;
  if (!msg) {
    msg = loading({
      duration: 0,
      iconClass: 'loading',
      customClass: 'fetch-loading',
      dangerouslyUseHTMLString: true,
      message: '<div><div class="loading-icon"></div>加载中</div>'
    });
  }
}

export function hide() {
  showCount -= 1;
  if (msg && showCount <= 0) {
    msg.close();
    msg = null;
  }
}
